/* eslint-disable no-use-before-define */
import {
  absoluteTopImpressionRateColumn, advertiserReportedRevenue, allConversionAdvertiserReportedRevenue, allConversionCPAColumn,
  allConversionRateColumn, allConversionRevenueOnAdSpendColumn, allConversionsColumn, averageCPCColumn, averageCPMColumn, clicksColumn, conversionRateColumn,
  conversionsColumn, CPAColumn, CTRColumn, impressionsColumn, returnOnAdSpendColumn, spendColumn, I18n, ColumnChooserCategory, SelectOption,
  ColumnRawData, ColumnChooserColumnOption, averageCPSColumn, salesCountColumn
} from '@bingads-webui-grid/well-known';
import { GridType, ScopeLevel } from '../../../constant';
import {
  ListingGroupColumn, AssetGroupNameColumn, IncludeExcludeColumn
} from '../../../rawColumns';

interface GetColumnChooserCategoriesOptions {
  gridType: GridType,
  i18n: I18n,
  scopeLevel: ScopeLevel,
  permissions: any,
}

export function getColumnChooserCategories(parameters: GetColumnChooserCategoriesOptions): ColumnChooserCategory[] {
  const {
    gridType, i18n, scopeLevel, permissions,
  } = parameters;

  const cpsColumnsEnabled = permissions && permissions.dynamic && permissions.dynamic.SupportCPSForPmax;

  const attributesCategory: ColumnChooserCategory = {
    name: i18n.getString(_TL_('Attributes')),
    type: 'Attributes',
    options: getAttributeColumnKeys(gridType, scopeLevel).map(o => buildCategoryOptionFromColumnRawData(o, i18n)),
  };

  const performaceCategory: ColumnChooserCategory = {
    name: i18n.getString(_TL_('Performance')),
    type: 'Performance',
    options: getPerfColumnKeys(cpsColumnsEnabled).map(o => buildCategoryOptionFromColumnRawData(o, i18n)),
  };

  const conversionsCategory: ColumnChooserCategory = {
    name: i18n.getString(_TL_('Conversions')),
    type: 'Conversions',
    options: getConvColumnKeys(cpsColumnsEnabled).map(o => buildCategoryOptionFromColumnRawData(o, i18n)),
  };

  return [
    attributesCategory,
    performaceCategory,
    conversionsCategory,
  ];
}

function buildCategoryOptionFromColumnRawData(column: ColumnRawData, i18n: I18n): ColumnChooserColumnOption {
  const selectOption = isLockedColumn(column.key);
  return {
    key: column.key,
    name: i18n.getString(column.name),
    selectOption,
  };
}

function isNotNullOrUndefined(value) {
  return value !== null && value !== undefined;
}

function getAttributeColumnKeys(gridType: GridType, scopeLevel: ScopeLevel) {
  return [
    IncludeExcludeColumn,
    ListingGroupColumn,
    (scopeLevel === ScopeLevel.Campaign) ? AssetGroupNameColumn : undefined,
  ].filter(isNotNullOrUndefined);
}

function getPerfColumnKeys(cpsColumnsEnabled) {
  const colmuns = [
    clicksColumn,
    impressionsColumn,
    CTRColumn,
    spendColumn,
    averageCPCColumn,
    averageCPMColumn,
    absoluteTopImpressionRateColumn,
  ];
  if (cpsColumnsEnabled) {
    colmuns.push(averageCPSColumn);
  }
  return colmuns;
}

function getConvColumnKeys(cpsColumnsEnabled) {
  const colmuns = [
    conversionRateColumn,
    conversionsColumn,
    CPAColumn,
    advertiserReportedRevenue,
    returnOnAdSpendColumn,
    allConversionsColumn,
    allConversionRateColumn,
    allConversionRevenueOnAdSpendColumn,
    allConversionAdvertiserReportedRevenue,
    allConversionCPAColumn,
  ];
  if (cpsColumnsEnabled) {
    colmuns.push(salesCountColumn);
  }
  return colmuns;
}

const lockColumns = new Set([
  IncludeExcludeColumn.key,
  ListingGroupColumn.key,
  AssetGroupNameColumn.key,
]);

function isLockedColumn(columnKey: string) {
  return lockColumns.has(columnKey) ? SelectOption.locked : SelectOption.optional;
}
